import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1111ad0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" PERSONAL DETAILS ")
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "character-name" }, "Character Name", -1))
const _hoisted_5 = ["value", "disabled"]
const _hoisted_6 = { class: "flex row" }
const _hoisted_7 = { class: "class" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "class" }, "Class", -1))
const _hoisted_9 = ["value", "disabled"]
const _hoisted_10 = { class: "pronouns" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pronouns" }, "Pronouns", -1))
const _hoisted_12 = ["value", "disabled"]
const _hoisted_13 = { class: "row flex" }
const _hoisted_14 = { class: "flair" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "patch-label",
  for: "patch"
}, "Patch", -1))
const _hoisted_16 = ["value", "disabled"]
const _hoisted_17 = { class: "flair" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "trinket" }, "Trinket", -1))
const _hoisted_19 = ["value", "disabled"]
const _hoisted_20 = { class: "row flex fill-height" }
const _hoisted_21 = { class: "notes" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "notes" }, "Notes", -1))
const _hoisted_23 = ["value", "disabled"]
const _hoisted_24 = { class: "conditions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConditionsList = _resolveComponent("ConditionsList")!
  const _component_ConditionModal = _resolveComponent("ConditionModal")!
  const _component_NewConditionModal = _resolveComponent("NewConditionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("input", {
        id: "character-name",
        type: "text",
        value: _ctx.name,
        disabled: !_ctx.editMode,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeName && _ctx.changeName(...args)))
      }, null, 40, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("input", {
          id: "class",
          type: "text",
          value: _ctx.characterClass,
          disabled: !_ctx.editMode,
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeClass && _ctx.changeClass(...args)))
        }, null, 40, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("input", {
          id: "pronouns",
          type: "text",
          value: _ctx.pronouns,
          disabled: !_ctx.editMode,
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changePronouns && _ctx.changePronouns(...args)))
        }, null, 40, _hoisted_12)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("textarea", {
          id: "patch",
          class: "plain-text",
          value: _ctx.patch,
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changePatch && _ctx.changePatch(...args))),
          disabled: !_ctx.editMode
        }, null, 40, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("textarea", {
          id: "trinket",
          class: "plain-text",
          value: _ctx.trinket,
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeTrinket && _ctx.changeTrinket(...args))),
          disabled: !_ctx.editMode
        }, null, 40, _hoisted_19)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("textarea", {
          id: "notes",
          value: _ctx.notes,
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeNotes && _ctx.changeNotes(...args))),
          disabled: _ctx.editMode
        }, null, 40, _hoisted_23)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_ConditionsList, {
          onViewDetails: _ctx.viewConditionDescription,
          onNew: _ctx.startNewCondition
        }, null, 8, ["onViewDetails", "onNew"])
      ])
    ]),
    _createVNode(_component_ConditionModal, {
      index: _ctx.conditionIndex,
      visible: _ctx.conditionDescriptionVisible,
      onClose: _ctx.closeConditionDescription
    }, null, 8, ["index", "visible", "onClose"]),
    _createVNode(_component_NewConditionModal, {
      visible: _ctx.newConditionVisible,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.newConditionVisible = false))
    }, null, 8, ["visible"])
  ]))
}